import { POINTMOVEMENTS_SERVICE } from "@/services/pointMovements.service.js";

const state = {getRankingOutput: {}, postPointMovementOutput: {}, getPointMovementsForUserOutput: {}, getTotalPointsForUserOutput: false,  getAvailablePointsForUserOutput: false };

const actions = {
    getRanking({ dispatch, commit }, queryParams) {
        dispatch('alert/clear', null, { root: true });
        commit('getRankingRequest');
    
        POINTMOVEMENTS_SERVICE.getRanking(queryParams)
            .then(
                output => {
                    commit('getRankingSuccess', output);
                },
                error => {
                    commit('getRankingFailure', error);
                    dispatch('alert/error', error, { root: true });
                }
            );
    },
    postPointMovement({ dispatch, commit }, input) {
        dispatch('alert/clear', null, { root: true });
        commit('postPointMovementRequest');
        
        POINTMOVEMENTS_SERVICE.postPointMovement(input)
            .then(
                output => {
                    commit('postPointMovementSuccess', output);
                },
                error => {
                    commit('postPointMovementFailure', error);
                    dispatch('alert/error', error, { root: true });
                }
            );
    },
    getPointMovementsForUser({ dispatch, commit }, queryParams) {
        dispatch('alert/clear', null, { root: true });
        commit('getPointMovementsForUserRequest');

        POINTMOVEMENTS_SERVICE.getPointMovementsForUser(queryParams)
            .then(
                output => {
                    commit('getPointMovementsForUserSuccess', output);
                },
                error => {
                    commit('getPointMovementsForUserFailure', error);
                    dispatch('alert/error', error, { root: true });
                }
            );
    },
    getTotalPointsForUser({ dispatch, commit }, queryParams) {
        dispatch('alert/clear', null, { root: true });
        commit('getTotalPointsForUserRequest');

        POINTMOVEMENTS_SERVICE.getTotalPointsForUser(queryParams)
            .then(
                output => {
                    commit('getTotalPointsForUserSuccess', output);
                },
                error => {
                    commit('getTotalPointsForUserFailure', error);
                    dispatch('alert/error', error, { root: true });
                }
            );
    },
    getAvailablePointsForUser({ dispatch, commit }, queryParams) {
        dispatch('alert/clear', null, { root: true });
        commit('getAvailablePointsForUserRequest');

        POINTMOVEMENTS_SERVICE.getAvailablePointsForUser(queryParams)
            .then(
                output => {
                    commit('getAvailablePointsForUserSuccess', output);
                },
                error => {
                    commit('getAvailablePointsForUserFailure', error);
                    dispatch('alert/error', error, { root: true });
                }
            );
    },
};

const mutations = {
    //getRanking
    getRankingRequest(state) {
    },
    getRankingSuccess(state, output) {
        state.getRankingOutput = output;
    },
    getRankingFailure(state) {
        state.getRankingOutput = false;
    },
    //postPointMovement
    postPointMovementRequest(state) {
        state.postPointMovementOutput = null;
    },
    postPointMovementSuccess(state, output) {
        state.postPointMovementOutput = true;
    },
    postPointMovementFailure(state) {
        state.postPointMovementOutput = false;
    },
    //getPointMovementsForUser
    getPointMovementsForUserRequest(state) {
    },
    getPointMovementsForUserSuccess(state, output) {
        state.getPointMovementsForUserOutput = output;
    },
    getPointMovementsForUserFailure(state) {
        state.getPointMovementsForUserOutput = false;
    },
    //getTotalPointsForUser
    getTotalPointsForUserRequest(state) {
    },
    getTotalPointsForUserSuccess(state, output) {
        state.getTotalPointsForUserOutput = output;
    },
    getTotalPointsForUserFailure(state) {
        state.getTotalPointsForUserOutput = false;
    },
    //getAvailablePointsForUser
    getAvailablePointsForUserRequest(state) {
    },
    getAvailablePointsForUserSuccess(state, output) {
        state.getAvailablePointsForUserOutput = output;
    },
    getAvailablePointsForUserFailure(state) {
        state.getAvailablePointsForUserOutput = false;
    },
};

export const pointMovements = {
    namespaced: true,
    state,
    actions,
    mutations
};